<template>
    <div class="customization-area">
        <CRow class="color-data-container-row mb-3">
            <CCol class="col-4">
                <label class="required">Colors</label>
                <p class="mb-1"><strong>Select color data container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select multiple :options="colors" v-model="journey.selected_colors" v-validate="{required: true}"
                              placeholder="NHL, MLB, Soccer" name="selected_colors">
                    </v-select>
                </div>
              <div v-if="errors && errors.first('selected_colors')" class="error_msg">
                {{ errors.first('selected_colors') }}
              </div>
            </CCol>
            <CCol class="col-4">
                <label>Product pattern</label>
                <p class="mb-1"><strong>Select pattern data container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select :options="patterns" v-model="journey.selected_pattern"
                              placeholder="Product patterns" name="selected_pattern">
                    </v-select>
                </div>
            </CCol>
       </CRow>

      <div class="mb-3 pb-4 border-bottom" style="border-color: #efefef !important;">
        <div class="d-flex align-items-center gap-1" v-b-toggle="`parts-container`">
          <span class="font-weight-bold fs-3 " v-b-tooltip="parts_container_collapse ? 'Collapse' : 'Expand'" :title="parts_container_collapse ? 'Collapse' : 'Expand'">Select color data container for parts</span>
          <button class="btn" style="outline: none; box-shadow: none" v-b-tooltip="parts_container_collapse ? 'Collapse' : 'Expand'" :title="parts_container_collapse ? 'Collapse' : 'Expand'">
            <b-icon-chevron-double-up v-if="parts_container_collapse" />
            <b-icon-chevron-double-down v-else />
          </button>
        </div>
        <b-collapse id="parts-container" v-model="parts_container_collapse">
          <CRow>
            <template v-for="(svgGroup, index) in svgGroups">
              <CCol class="col-4 mt-3" :key="index">
                <strong><p class="mb-1" :key="index"> {{ svgGroup.id }}</p></strong>
                <v-select v-model="svgGroup.color_container_id" :reduce="color => color.id" :options="colors"
                          placeholder="NHL, MLB, Soccer" name="selected_colors">
                </v-select>
              </CCol>
            </template>
          </CRow>
        </b-collapse>
      </div>

        <CRow>
            <CCol class="col-2 mb-3">
                <div class="description-toggle-holder">
                    <label class="basci_switch required">Logos</label>
                      <div>
                        <b-form-checkbox v-model="journey.allow_logo_upload" size="lg" name="check-button" switch></b-form-checkbox>
                      </div>
                </div>
            </CCol>
        </CRow>
        <CRow>
            <CCol v-if="journey.allow_logo_upload" class="col-12">
                <CRow>
                    <CCol class="col-3">
                        <p><strong>Max amount of logos allowed</strong></p>
                        <div class="description-toggle-holder logo-number-holder mb-3">
                          <div>
                            <b-form-checkbox v-model="journey.limit_max_logo_upload" size="lg" name="check-button" switch></b-form-checkbox>
                          </div>
                            <div class="logo-number-area">
                                <CInput
                                  v-if="journey.limit_max_logo_upload"
                                  addLabelClasses="required"
                                  placeholder="1"
                                  type="text"
                                  v-model="journey.max_logo_allowed"
                                  @change="LimitLogoPlacement"
                                  name="design_name"
                                >
                                </CInput>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol class="col-5">
                        <p class="required"><strong>Logo placement</strong></p>
                    </CCol>
                    <CCol class="col-2">
                        <p>Height in millimeters</p>
                    </CCol>
                    <CCol class="col-2">
                        <p>Lock</p>
                    </CCol>
                </CRow>
                <CRow v-for="(item, logoindex) in journey.logos_setting" :key="'logo-'+logoindex" class="mb-3 alter-rows">
                  <div class="row-style d-flex">
                    <span class="remove-icon" v-if="logoindex != 0" @click="removeLogoPlacement(logoindex)">
                      <BIconX />
                    </span>
                    <CCol class="col-3">
                        <div class="align-fields">
                            <CInput
                            addLabelClasses="required"
                            placeholder="X"
                            type="text"
                            v-model="item.x_axis"
                            :name="`logo_position_x_${logoindex}`"
                            :id="`logo_position_x_${logoindex}`"
                            v-validate="'required|decimal:5'"
                            :class="errors && errors.first(`logo_position_x_${logoindex}`) ? 'v-error' : ''"
                            >
                            </CInput>
                            <b-tooltip v-if="errors && errors.first(`logo_position_x_${logoindex}`)" :target="`logo_position_x_${logoindex}`" placement="top">
                             {{errors.first(`logo_position_x_${logoindex}`)}}
                            </b-tooltip>

                            <CInput
                            addLabelClasses="required"
                            placeholder="Y"
                            type="text"
                            v-model="item.y_axis"
                            :name="`logo_position_y_${logoindex}`"
                            v-validate="'required|decimal:5'"
                            :class="errors && errors.first(`logo_position_y_${logoindex}`) ? 'v-error' : ''"
                            :id="`logo_position_y_${logoindex}`"
                            >
                            </CInput>
                            <b-tooltip v-if="errors && errors.first(`logo_position_y_${logoindex}`)" :target="`logo_position_y_${logoindex}`" placement="top">
                              {{errors.first(`logo_position_y_${logoindex}`)}}
                            </b-tooltip>
                        </div>
                    </CCol>
                    <CCol class="col-7">
                        <div class="customize-setting-holder">
                            <div class="rotate-logo-area">
                                <CInput
                                addLabelClasses="required"
                                placeholder="rot°"
                                type="text"
                                v-model="item.rotation"
                                :name="`logo_rotate_${logoindex}`"
                                v-validate="'required|decimal:5'"
                                :class="errors && errors.first(`logo_rotate_${logoindex}`) ? 'v-error' : ''"
                                :id="`logo_rotate_${logoindex}`"
                                >
                            </CInput>
                            <b-tooltip v-if="errors && errors.first(`logo_rotate_${logoindex}`)" :target="`logo_rotate_${logoindex}`" placement="top">
                              {{errors.first(`logo_rotate_${logoindex}`)}}
                            </b-tooltip>
                            </div>
                            <CInput
                            addLabelClasses="required"
                            placeholder="height"
                            type="text"
                            v-model="item.height"
                            :name="`logo_height_${logoindex}`"
                            v-validate="'required|decimal:5|min_value:10'"
                            :class="errors && errors.first(`logo_height_${logoindex}`) ? 'v-error' : ''"
                            :id="`logo_height_${logoindex}`"
                            >
                            </CInput>
                            <b-tooltip v-if="errors && errors.first(`logo_height_${logoindex}`)" :target="`logo_height_${logoindex}`" placement="top">
                              {{errors.first(`logo_height_${logoindex}`)}}
                            </b-tooltip>
                          <div class="logo-placement-area">
                            <CInput
                                addLabelClasses="required"
                                placeholder="Name logo placement (e.g left sleeve)"
                                type="text"
                                v-model="item.name_of_placement"
                                :name="`logo_placement_${logoindex}`"
                                v-validate="'required'"
                                :class="errors && errors.first(`logo_placement_${logoindex}`) ? 'v-error' : ''"
                                :id="`logo_placement_${logoindex}`"
                            >
                            </CInput>
                            <b-tooltip v-if="errors && errors.first(`logo_placement_${logoindex}`)" :target="`logo_placement_${logoindex}`" placement="top">
                              {{errors.first(`logo_placement_${logoindex}`)}}
                            </b-tooltip>
                          </div>
                            <div class="shirt-side-area">
                                <div class="dropdown_wrapper">
                                    <v-select v-validate="'required'"
                                              :name="`logo_side_${logoindex}`"
                                              v-model="item.side" :options="sideOptions"
                                              placeholder="Front"
                                              :class="errors && errors.first(`logo_side_${logoindex}`) ? 'v-error' : ''"
                                              :id="`logo_side_${logoindex}`"

                                    ></v-select>
                                    <b-tooltip v-if="errors && errors.first(`logo_side_${logoindex}`)" :target="`logo_side_${logoindex}`" placement="top">
                                      {{errors.first(`logo_side_${logoindex}`)}}
                                    </b-tooltip>
                                </div>
                            </div>

                            <div>
                                <div class="dropdown_wrapper">
                                    <v-select
                                              :name="`logo_tech_${logoindex}`"
                                              v-model="item.logoTechnologies" :options="logotechnologies"
                                              placeholder="Logo Technology"
                                              multiple
                                              :class="errors && errors.first(`logo_tech_${logoindex}`) ? 'v-error' : ''"
                                              :id="`logo_tech_${logoindex}`"

                                    ></v-select>
                                    <b-tooltip v-if="errors && errors.first(`logo_tech_${logoindex}`)" :target="`logo_tech_${logoindex}`" placement="top">
                                      {{errors.first(`logo_tech_${logoindex}`)}}
                                    </b-tooltip>
                                </div>
                            </div>

                        </div>
                    </CCol>
                    <CCol class="col-2 d-flex align-items-center">
                    <div class="align-fields">
                      <b-form-checkbox
                          :id="'checkbox_'+logoindex"
                          v-model="item.is_locked"
                          name="is_default"
                      >
                      </b-form-checkbox>
                    </div>
                  </CCol>
                  </div>
                  <div>
                    <template v-if="logoindex != 0">
                      <b-form-checkbox
                          :id="'checkbox_following_logo'+logoindex"
                          v-model="item.logos_follows_product"
                      >Following Products</b-form-checkbox>
                    </template>
                    <div class="dropdown_wrapper" v-if="item.logos_follows_product && logoindex != 0">
                      <v-select v-validate="'required'" multiple
                                v-model="item.following_product_ids"
                                :options="product_ids"
                                placeholder="Select Products"
                                :class="errors && errors.first(`logo_following_${logoindex}`) ? 'v-error' : ''"
                                :id="`logo_following_${logoindex}`"
                                :name="`logo_following_${logoindex}`"
                      ></v-select>
                      <b-tooltip v-if="errors && errors.first(`logo_following_${logoindex}`)" :target="`logo_following_${logoindex}`" placement="top">
                        {{errors.first(`logo_following_${logoindex}`)}}
                      </b-tooltip>
                    </div>
                  </div>
                </CRow>
              <div v-if="journey.limit_max_logo_upload" class="d-flex justify-content-end">
                <b-button v-if="journey.max_logo_allowed > journey.logos_setting.length" @click="AddLogoPlacement" class="btn-add-fields mt-3">
                  <BIconPlus />
                </b-button>
              </div>

              <div v-else @click="AddLogoPlacement" class="d-flex justify-content-end">
                <b-button  class="btn-add-fields mt-3">
                  <BIconPlus />
                </b-button>
              </div>
            </CCol>
        </CRow>

        <CRow class="mb-3">
            <CCol class="col-4">
                <div class="description-toggle-holder justify-content-lg-start">
                    <label class="basci_switch">Name/number placement</label>
                    <div class="pl-3">
                        <b-form-checkbox v-model="journey.allow_name_number" switch size="lg" ></b-form-checkbox>
                    </div>
                </div>
            </CCol>
            <CCol class="col-4">
                <div class="description-toggle-holder justify-content-lg-start">
                    <label class="basci_switch">Preview Text On Mock-Up</label>
                    <div class="pl-3">
                        <b-form-checkbox v-model="journey.preview_custom_texts" switch size="lg" ></b-form-checkbox>
                    </div>
                </div>
            </CCol>
        </CRow>
        <CRow v-if="journey.allow_name_number" class="mb-5 font-container-row">
            <CCol class="col-3">
                <p class="required"><strong>Select font data container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select v-model="journey.name_number_fonts"   name="name_number_fonts" multiple :options="fonts" v-validate="{required: true}" placeholder="Arial"></v-select>
                </div>
              <div v-if="errors && errors.first('name_number_fonts')" class="error_msg">
                {{ errors.first('name_number_fonts') }}
              </div>
            </CCol>
            <CCol class="col-3">
                <p class="required"><strong>Select color data container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select v-model="journey.name_number_colors" name="name_number_colors" multiple :options="colors" v-validate="{required: true}" placeholder="NHL, MLB, Soccer etc."></v-select>
                </div>
              <div v-if="errors && errors.first('name_number_colors')" class="error_msg">
                {{ errors.first('name_number_colors') }}
              </div>
            </CCol>
          <CCol class="col-3">
            <p class="required"><strong>Allow extra text</strong></p>
            <div class="dropdown_wrapper">
                <b-form-checkbox v-model="journey.allow_extra_text" switch size="lg"></b-form-checkbox>
            </div>
          </CCol>
        </CRow>
        <div v-if="journey.allow_name_number">
          <CRow v-for="(product_text, productTextIndex) in journey.product_texts" :key="`product_texts_${productTextIndex}`" class="mb-3 name-placement-settings alter-rows">
            <template v-if="productTextIndex == 0">
              <CCol class="col-3">
                <p class="required"><strong>Name placement</strong></p>
              </CCol>
              <CCol class="col-3">
                <p class="required"><strong>Type</strong></p>
              </CCol>
              <CCol class="col-4">
                <p class="required"><strong>Following Products</strong></p>
              </CCol>
              <CCol class="col-2">
                <p class="required"><strong>Add Text</strong></p>
              </CCol>
            </template>
            <div class="row-style flex-wrap d-flex">
              <span class="remove-icon" v-if="productTextIndex != 0" @click="removeNumRow(pcount)">
                  <BIconX />
                </span>
              <CCol class="col-3">
                <div class="customize-setting-holder">
                  <div class="logo-placement-area">
                    <CInput
                        addLabelClasses="required"
                        placeholder="Name  placement (e.g left sleeve)"
                        type="text"
                        v-model="product_text.label"
                        :name="`product_text_${productTextIndex}_label`"
                        :key="`product_text_${productTextIndex}_label`"
                        :id="`product_text_${productTextIndex}_label`"
                        v-validate="'required'"
                        :class="errors && errors.first(`product_text_${productTextIndex}_label`) ? 'v-error' : ''"
                    >
                    </CInput>
                    <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_label`)" :target="`product_text_${productTextIndex}_label`" placement="top">
                      {{errors.first(`product_text_${productTextIndex}_label`)}}
                    </b-tooltip>
                  </div>

                </div>
              </CCol>
              <CCol class="col-3">
                <div class="shirt-side-area">
                  <div class="dropdown_wrapper">
                    <v-select v-model="product_text.type"
                              :options="productTextTypes"
                              placeholder="Name/Number/Team Name"
                              :name="`product_text_${productTextIndex}_type`"
                              :key="`product_text_${productTextIndex}_type`"
                              :id="`product_text_${productTextIndex}_type`"
                              v-validate="'required'"
                              :class="errors && errors.first(`product_text_${productTextIndex}_type`) ? 'v-error' : ''"
                    ></v-select>
                    <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_type`)" :target="`product_text_${productTextIndex}_type`" placement="top">
                      {{errors.first(`product_text_${productTextIndex}_type`)}}
                    </b-tooltip>
                  </div>
                </div>
              </CCol>
              <CCol class="col-4">
                <div class="dropdown_wrapper">
                  <v-select multiple
                            v-model="product_text.following_products"
                            :options="product_ids"
                            placeholder="Following Products"
                            :name="`product_text_${productTextIndex}_following_products`"
                            :id="`product_text_${productTextIndex}_following_products`"
                           ></v-select>
                </div>
              </CCol>
              <CCol class="col-2">
                <b-button @click="addProductText('product', productTextIndex)" class="btn-add-fields mt-3">
                  <BIconPlus />
                </b-button>
              </CCol>
              <template v-for="(product_text_item, productTextItemIndex) in product_text.items">
                  <div :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_div`" class="row">
                    <template v-if="productTextItemIndex == 0">
                      <CCol class="col-1">
                        <p class="required"><strong>X position</strong></p>
                      </CCol>
                      <CCol class="col-1">
                        <p class="required"><strong>Y position</strong></p>
                      </CCol>
                      <CCol class="col-1">
                        <p class="required"><strong>Rotation</strong></p>
                      </CCol>
                      <CCol class="col-1">
                        <p class="required"><strong>Height</strong></p>
                      </CCol>
                      <CCol class="col-2">
                        <p class="required"><strong>Label</strong></p>
                      </CCol>
                      <CCol class="col-2">
                        <p class="required"><strong>Placement</strong></p>
                      </CCol>

                      <CCol class="col-1">
                        <p class="required"><strong>Arc Allowed</strong></p>
                      </CCol>
                      <CCol class="col-1">
                        <p class="required"><strong>Outline</strong></p>
                      </CCol>
                      <CCol class="col-2"></CCol>


                    </template>
                    <span class="remove-icon" @click="removeProductText(productTextIndex)" v-if="productTextIndex != 0">
                      <BIconX />
                    </span>
                    <CRow class="mb-3 name-placement-settings alter-rows" style="margin-left: 16px !important; margin-right: 16px !important;">
                      <CCol class="col-1">
                        <CInput
                            addLabelClasses="required"
                            placeholder="X"
                            type="text"
                            v-model="product_text_item.x_axis"
                            :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`"
                            :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`"
                            :id="`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`"
                            v-validate="'required|decimal:5'"
                            :class="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`) ? 'v-error' : ''"
                        >
                        </CInput>
                        <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`)"
                                   :target="`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`" placement="top">
                          {{errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`)}}
                        </b-tooltip>
                      </CCol>
                      <CCol class="col-1">
                        <CInput
                            addLabelClasses="required"
                            placeholder="Y"
                            type="text"
                            v-model="product_text_item.y_axis"
                            :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`"
                            :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`"
                            :id="`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`"
                            v-validate="'required|decimal:5'"
                            :class="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`) ? 'v-error' : ''"
                        >
                        </CInput>
                        <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`)"
                                   :target="`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`" placement="top">
                          {{errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`)}}
                        </b-tooltip>
                      </CCol>
                      <CCol class="col-1">
                        <CInput
                            addLabelClasses="required"
                            placeholder="Rotation"
                            type="text"
                            v-model="product_text_item.rotation"
                            :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`"
                            :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`"
                            :id="`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`"
                            v-validate="'required|decimal:5'"
                            :class="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`) ? 'v-error' : ''"
                        >
                        </CInput>
                        <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`)"
                                   :target="`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`" placement="top">
                          {{errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`)}}                        </b-tooltip>
                      </CCol>
                      <CCol class="col-1">
                        <CInput
                            addLabelClasses="required"
                            placeholder="Height"
                            type="text"
                            v-model="product_text_item.height"
                            :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_height`"
                            :id="`product_text_${productTextIndex}_item_${productTextItemIndex}_height`"
                            v-validate="'required|decimal:5|min_value:10'"
                            :class="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_height`) ? 'v-error' : ''"
                        >
                        </CInput>
                        <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_height`)" :target="`product_text_${productTextIndex}_item_${productTextItemIndex}_height`" placement="top">
                          {{errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_height`)}}
                        </b-tooltip>
                      </CCol>
                      <CCol class="col-2">
                        <CInput
                            addLabelClasses="required"
                            placeholder="Label"
                            type="text"
                            v-model="product_text_item.label"
                            :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_label`"
                            :id="`product_text_${productTextIndex}_item_${productTextItemIndex}_label`"
                            :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_label`"
                            v-validate="'required'"
                            :class="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_label`) ? 'v-error' : ''"
                        >
                        </CInput>
                        <b-tooltip v-if="errors && errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_label`)" :target="`product_text_${productTextIndex}_item_${productTextItemIndex}_label`" placement="top">
                          {{errors.first(`product_text_${productTextIndex}_item_${productTextItemIndex}_label`)}}
                        </b-tooltip>
                      </CCol>
                      <CCol class="col-2">
                        <div class="dropdown_wrapper">
                          <!-- Reversible products (AB#19680): four combined side+face options,
                               stored as the composite placement ('Front'|'Back') + face fields -->
                          <v-select :value="textPlacementValue(product_text_item)"
                                    @input="setTextPlacement(product_text_item, $event)"
                                    v-validate="'required'"
                                    :options="textPlacementOptions"
                                    placeholder="Placement"
                                    :name="`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`"
                                    :key="`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`"
                                    :id="`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`"
                                    :class="errors && errors.first(`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`) ? 'v-error' : ''"></v-select>
                          <b-tooltip v-if="errors && errors.first(`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`)" :target="`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`" placement="top">
                            {{errors.first(`product_text_${productTextItemIndex}_item_${productTextItemIndex}_placement`)}}
                          </b-tooltip>
                        </div>
                      </CCol>
                      <CCol class="col-1">
                        <b-form-checkbox v-model="product_text_item.arc_text_allowed" switch size="lg"
                                         :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_arc_text_allowed`"
                                         :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_arc_text_allowed`"
                        ></b-form-checkbox>
                      </CCol>
                      <CCol class="col-1">
                        <b-form-checkbox v-model="product_text_item.outline_enabled" switch size="lg"
                                         :key="`product_text_${productTextIndex}_item_${productTextItemIndex}_outline_enabled`"
                                         :name="`product_text_${productTextIndex}_item_${productTextItemIndex}_outline_enabled`"
                        ></b-form-checkbox>
                      </CCol>
                      <CCol class="col-2">
                         <span @click="addProductText('product_item', productTextIndex)" style="font-size: 2em !important; cursor: pointer">
                            <BIconPlus />
                        </span>
                         <span @click="removeProductText(productTextIndex, productTextItemIndex)"  v-if="productTextItemIndex > 0"
                               style="font-size: 2em !important; cursor: pointer">
                           <BIconX />
                        </span>
                      </CCol>
                    </CRow>
                  </div>
              </template>
            </div>
            <div>
            </div>
          </CRow>
        </div>
        <CRow class="mt-5">
            <CCol>
                <label class="required">Team Roster</label>
            </CCol>
        </CRow>
        <CRow class="mb-5">
            <CCol class="col-3">
                <p class="required"><strong>Select size data container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select :options="sizeSelectOptions" v-model="journey.size_container" name="size_container"  placeholder="Size"></v-select>
                </div>
              <div v-if="errors && errors.first('size_container')" class="error_msg">
                {{ errors.first('size_container') }}
              </div>
            </CCol>
<!--            <CCol class="col-3">
                <p class="required"><strong>Select accessories container</strong></p>
                <div class="dropdown_wrapper">
                    <v-select multiple :options="accessories" v-model="journey.accessories_container" name="accessories_container"  placeholder="NHL, MLB, Soccer etc."></v-select>
                </div>
              <div v-if="errors && errors.first('accessories_container')" class="error_msg">
                {{ errors.first('accessories_container') }}
              </div>
            </CCol>-->
            <CCol class="col-2 cap-letter">
                <p class="required"><strong>Cap letter available?</strong></p>
                <div>
                    <b-form-checkbox v-model="journey.roster_caps_letter" switch size="lg"></b-form-checkbox>
                </div>
            </CCol>
        </CRow>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
          <b-button title="Previous step" @click="fieldsTab" class="light" variant="primary"><BIconArrowLeft /></b-button>
        </div>
        <div class="d-flex gap-2">
          <b-button variant="primary" @click="SaveProduct(2)">Save and Stay</b-button>
          <b-button variant="primary" @click="SaveProduct(0)">Save and Close</b-button>
        </div>
        <div></div>
      </div>

    </div>
</template>
<script>
import { http } from "@/config/httpCommon"
import { PRODUCT_TEXT_TYPES } from './productTextTypes'
export default {
  props: {
    product_type: Object,
    product_id: Number,
    factory_id: Number,
    svgGroups: Array,
    // Live reversible flag from tab 2 (AB#19680) — the saved journey only
    // carries it after a full reload, so during creation this prop is the
    // only signal that the four-way side/face options should render.
    reversible: { type: Boolean, default: false }
  },
  watch: {
    reversible(value) {
      this.is_reversible = !!value;
    }
  },
  computed: {
    getJourney() {
      return this.$store.getters.getJourney
    },
    // Reversible products (AB#19064/AB#19680) get four placement options —
    // the option id encodes side+face ('front'|'back'|'front-inside'|'back-inside');
    // Add.vue splits it back into the composite side + face fields (AB#19554).
    sideOptions() {
      if (!this.is_reversible) {
        return this.sides;
      }
      return [
        {id: 'front', label: 'Front (outside)'},
        {id: 'back', label: 'Back (outside)'},
        {id: 'front-inside', label: 'Front (inside)'},
        {id: 'back-inside', label: 'Back (inside)'},
      ];
    },
    // Same four-way expansion for the product-text placement select; text rows
    // store side and face as separate fields, so options stay plain strings.
    textPlacementOptions() {
      if (!this.is_reversible) {
        return ['Front', 'Back'];
      }
      return ['Front (outside)', 'Back (outside)', 'Front (inside)', 'Back (inside)'];
    },
    isSuperAdmin() {
      return this.$store.getters.roleName === 'superadmin'
    },
    sizeSelectOptions() {
      const list = this.sizes.length ? this.sizes : (this.$store.getters.getSizes || [])
      if (!this.isSuperAdmin) return list
      return list.map((s) => ({
        ...s,
        label: this.formatSizeContainerLabel(s)
      }))
    }
  },
  async created() {
    let self = this;
    this.$store.commit('set', ['showLoader', true]);
    try {
      let params = `&product_id=${this.product_id}&paginate=false`;
      await this.$store.dispatch("getColors",params);
      await this.$store.dispatch("getFonts", params);
      await this.$store.dispatch("getPatterns", params);
      await this.$store.dispatch('getProductSizes', params);
      let product_ids = await http.get('product_details')
      if (product_ids.status == 200){
        this.product_ids = product_ids.data
      }
      this.sizes = await this.$store.getters.getSizes;
      await this.$store.dispatch("getLogoTechnologies"); // Fetch data first
      this.logotechnologies = await this.$store.getters.getLogoTechnologies;

      this.colors = this.$store.getters.getColors;
      this.fonts = this.$store.getters.getFonts;
      this.patterns = this.$store.getters.getPatterns;
    /*  let get_accessories = await http.get(`getAccessories`);
      let accessories = get_accessories.data;
      for (let acc = 0; acc < accessories.length; acc++) {
        this.accessories.push({
          id: accessories[acc].id,
          label: accessories[acc].name,
        })
      }*/

      if (Object.keys(this.getJourney).length) {
        let journey = this.getJourney;
        this.is_reversible = journey.is_reversible == 1;
        let patterns = journey.patterns;
        for (let pat = 0; pat < patterns.length; pat++) {
          this.journey.selected_pattern.push({
            id: patterns[pat].id,
            label: patterns[pat].file_name,
          });
        }
        this.journey.logos_setting = journey.logos_setting
        let colors = journey.colors;
        for (let clr = 0; clr < colors.length; clr++) {
          this.journey.selected_colors.push({
            id: colors[clr].id,
            label: colors[clr].file_name,
          });
        }
        this.journey.allow_logo_upload = (journey.is_logo_allowed == 1) ? true : false;
        this.journey.max_logo_allowed = journey.allowed_logos_count;
        this.journey.allow_extra_text = (journey.allow_extra_text == 1) ? true : false
        this.journey.allow_name_number = (journey.allow_name_number == 1) ? true : false
        this.journey.preview_custom_texts = (journey.preview_custom_texts == 1) ? true : false

        if (journey.allowed_logos_count > 0) {
          this.journey.limit_max_logo_upload = true;
        }
        this.journey.roster_caps_letter = (journey.is_cap_letter_available == 1) ? true : false;
        // Team Roaster
        // let addons = journey.addons;
        // if (addons.length > 0) {
        //   for (let addIndex = 0; addIndex < addons.length; addIndex++) {
        //     this.journey.accessories_container.push({
        //       id: addons[addIndex].addon_id,
        //       label: this.getAddOn(addons[addIndex].addon_id)
        //     })
        //   }
        // }
        let selected_sizes = journey.sizes;
        for (let sizeIndex = 0; sizeIndex < selected_sizes.length; sizeIndex++) {
          let label = this.getSize(selected_sizes[sizeIndex].id);
          if (label != '') {
            this.journey.size_container = {
              id: selected_sizes[sizeIndex].id,
              label: label
            };
          }
        }

        //product logos
        let logoSsetting = journey.logos_setting;
        this.journey.logos_setting = [];

        if (logoSsetting.length > 0) {
          for (let inc = 0; inc < logoSsetting.length; inc++) {
            const logoBaseSide = logoSsetting[inc].side == 'front' ? 'front' : 'back';
            const logoFace = logoSsetting[inc].face || 'outside';
            const logoOptionId = logoFace === 'inside' ? `${logoBaseSide}-inside` : logoBaseSide;
            let logo = this.sideOptions.find(opt => opt.id === logoOptionId)
              || {id: logoBaseSide, label: logoBaseSide === 'front' ? 'Front' : 'Back'};
            this.journey.logos_setting.push({
              x_axis: logoSsetting[inc].x_axis,
              y_axis: logoSsetting[inc].y_axis,
              rotation: logoSsetting[inc].rotation,
              height: logoSsetting[inc].height,
              // height: logoSsetting[inc].height,
              name_of_placement: logoSsetting[inc].name_of_placement,
              side: logo,
              logos_follows_product: (logoSsetting[inc].logos_follows_product== 1) ? true : false,
              following_product_ids: this.getFollowingProduct(logoSsetting[inc].following_product_ids),
              is_locked: (logoSsetting[inc].is_locked == 1) ? true : false,
              logoTechnologies: logoSsetting[inc].logo_technologies,
            });
          }
        } else {
          this.journey.logos_setting.push({
            x_axis: '',
            y_axis: '',
            rotation: '',
            height: '',
            // height: '',
            name_of_placement: '',
            side: {id: 'front', label: 'Front'},
            is_locked: false,
            logoTechnologies:[]
          });
        }


        //name number fonts
        let namefonts = journey.namefonts;
        this.journey.name_number_fonts = []
        if (namefonts.length && this.journey.allow_name_number) {
          for (let count = 0; count < namefonts.length; count++)
          {
            this.journey.name_number_fonts.push({
              id: namefonts[count].id,
              label: namefonts[count].file_name,
            })
          }
        }
        let namecolors = journey.namecolors;
        this.journey.name_number_colors = [];
        if(this.journey.allow_name_number){
          for (let i = 0; i < namecolors.length; i++) {
            this.journey.name_number_colors.push({
              id: namecolors[i].id,
              label: namecolors[i].file_name,
            });
          }
        }
        // name or number records
         self.setProductTexts(journey.product_texts)
        let productnames = journey.productnames;
        this.journey.name_numbers_placement = [];
        if (productnames.length > 0 && this.journey.allow_name_number) {
          for (let myindex = 0; myindex < productnames.length; myindex++) {
            let namenumber = productnames[myindex];
            const nnBaseSide = (typeof namenumber.side === 'string' && namenumber.side.toLowerCase() == 'front') ? 'front' : 'back';
            const nnFace = namenumber.face || 'outside';
            const nnOptionId = nnFace === 'inside' ? `${nnBaseSide}-inside` : nnBaseSide;
            let side = this.sideOptions.find(opt => opt.id === nnOptionId)
              || {id: nnBaseSide, label: nnBaseSide === 'front' ? 'Front' : 'Back'};
            let type = null;
            if (namenumber.type == 'number') {
              type = {id: 'number', label: 'Number'}
            } else if(namenumber.type == 'name') {
              type = {id: 'name', label: 'Name'}
            }else{
              type = {id: 'text', label: 'Team name'}
            }
            this.journey.name_numbers_placement.push({
              x_axis: namenumber.x_axis,
              y_axis: namenumber.y_axis,
              rotation: namenumber.rotation,
              // height: namenumber.height,
              height: namenumber.height,
              name_of_placement: namenumber.name_of_placement,
              side: side,
              arc_text_allowed: (namenumber.arc_text_allowed == 1) ? true : false,
              outline_enabled: (namenumber.outline_enabled == 1) ? true : false,
              type: type,
              is_locked: (namenumber.is_locked == 1) ? true : false,
              text_follows_product: (namenumber.text_follows_product == 1)? true: false,
              following_product_ids: this.getFollowingProduct(namenumber.following_product_ids),
              name_of_placement_follow:[],
            });
          }
        } else {
          this.journey.name_numbers_placement.push({
            x_axis: '',
            y_axis: '',
            rotation: '',
            // height: '',
            height: '',
            type : {id: 'name', label: 'Name'},
            name_of_placement: '',
            side: {id: 'front', label: 'Front'},
            arc_text_allowed: false,
            outline_enabled: false,
            name_or_number: '',
            is_locked: false,
            name_of_placement_follow:[],
          });
        }
      } else {
        self.journey.product_texts = [self.getProductTextsDefaultObject()];
      }
      // name number colors
    this.addValidationRules()
    this.$store.commit('set', ['showLoader', false]);
  }catch(err) {
    this.$store.commit('set', ['showLoader', false]);
    this.showError(err);
  }
  },
  data(){
    return{
      product_ids:[],
      parts_container_collapse: false,
      journey: {
        show_description: true,
        description: "",
        allow_logo_upload: true,
        logo_upload_limit: '',
        limit_max_logo_upload: false,
        max_logo_allowed: 1,
        preview_custom_texts: 1,
        logos_setting:[
          {
            x_axis: '',
            y_axis: '',
            rotation: '',
            height: '',
            // height: '',
            name_of_placement: '',
            side: {id: 'front', label: 'Front'},
            is_locked: false,
            logos_follows_product:false,
            following_product_ids:[],
            logoTechnologies:[],
          }
        ],
        name_numbers_placement: [
          {
            x_axis: '',
            y_axis: '',
            rotation: '',
            // height: '',
            type:{id: 'name', label: 'Name'},
            height: '',
            name_of_placement: '',
            side: {id: 'front', label: 'Front'},
            arc_text_allowed: false,
            outline_enabled: false,
            is_locked: false,
            text_follows_product:false,
            following_product_ids:[],
            name_of_placement_follow:[],
            logoTechnologies:[],
          }
        ],
        product_texts: [],
        selected_colors: [],
        selected_pattern: [],
        allow_name_number: true,
        allow_extra_text: true,
        name_number_fonts: [],
        name_number_colors: [],
        size_container: {},
        accessories_container: [],
        roster_caps_letter: false,
        svg_group_color_container: []
      },
      colors: [],
      fonts: [],
      patterns: [],
      sides:[
        {id: 'front', label: 'Front'},
        {id: 'back', label: 'Back'},
      ],
      is_reversible: false,
      productTextTypes: [...PRODUCT_TEXT_TYPES],
      accessories: [],
      base_url: process.env.VUE_APP_FILE_URL,
      style_index: '',
      sizes: [],
      logotechnologies:[],
      design_error_messages: {
        custom: {
          selected_colors: {
            required: 'Color field is required'
          },
          name_number_fonts: {
            required: 'Name number fonts is required'
          },
          name_number_colors: {
            required: 'Name number colors is required'
          },
          size_container: {
            required: 'Size data container is required'
          },
          accessories_container: {
            required: 'Accessories container is required'
          }
        }
      }
    }
  },
  methods:{
    selectProducts(event){
      if (event == true)
        console.log("fine")
    },
    getAddOn(id){
      if (this.accessories.length > 0){
        let index= this.accessories.findIndex(acc => acc.id == id);
        return this.accessories[index].label;
      }
    },
    formatSizeContainerLabel(size) {
      if (!size) return ''
      const label = size.label || ''
      const src = (size.sourceable_name || '').trim()
      const isSuperadminSource =
        src.toLowerCase() === 'superadmin'
      if (this.isSuperAdmin && src && !isSuperadminSource) {
        return `${label} (${size.sourceable_name})`
      }
      return label
    },
    getSize(id){
      let sizes = this.$store.getters.getSizes
      if(sizes){
        let index= sizes.findIndex(size => size.id == id);
        if(sizes[index]){
          return this.formatSizeContainerLabel(sizes[index])
        }
      }

      return ''
    },
    fieldsTab(){
      this.$emit('fields-tab', true);
    },
    async SaveProduct(proceed){
      this.addValidationRules()

      let valid = await this.$validator.validate();
      if(valid) {
        let status = await this.validateCustomizeJouney();
        if(status){
          this.journey.svg_group_color_container = this.svgGroups.filter(svgGroup => svgGroup.color_container_id)
          this.$emit('finalStep', this.journey,proceed);
        } else {
          this.showToast("Please fill all required fields", "error");
        }
      } else {
        this.showToast("Please fill all required fields", "error");
      }

    },
    async validateCustomizeJouney(){

      const RegExp = /^\d*\.?\d*$/;
      let valid = true;
      let message = '';
      if(this.journey.selected_colors.length == 0 && (this.product_type.code && this.product_type.code=='customized' || this.product_type.code=='personalized')){
        valid = false;
        message = 'Colors data container is required';
      }else if(this.journey.allow_logo_upload){

        if(this.journey.limit_max_logo_upload && isNaN(this.journey.max_logo_allowed)){
          message = 'Maximum number of  logo upload should be integer';
          valid = false;
        }else if(this.journey.logos_setting.length > this.journey.max_logo_allowed){

          // this.journey.logos_setting = this.journey.logos_setting.slice(0, this.journey.max_logo_allowed);
        }

        if(this.journey.logos_setting.length > 0)
        {
          for (let i=0; i< this.journey.logos_setting.length; i++){
            let logo = this.journey.logos_setting[i];
            if(logo.x_axis == '' || !RegExp.test(logo.x_axis)){
              valid = false;
              message = 'logo placement of row '+(++i)+', x-axis is required and must to number';
            }else if(logo.y_axis == '' || !RegExp.test(logo.y_axis)){
              valid = false;
              message = 'logo placement of row '+(++i)+', y-axis is required and must to number';
            }else if(!RegExp.test(logo.rotation)){
              valid = false;
              message = 'logo placement of row '+(++i)+', rotation must to number';
            }else if(logo.height == '' || !RegExp.test(logo.height)){
              valid = false;
              message = 'logo placement of row '+(++i)+', height is required and must to number';
            }else if(parseFloat(logo.height) < 10){
              valid = false;
              message = 'logo placement of row '+(++i)+', height should be greater than or equal to 10';
            }
            else if(logo.logos_follows_product == true && !logo.following_product_ids.length){
              valid = false;
              message = 'Select product';
            }
            else if(!logo.side || logo.side == ''){
              valid = false;
              message = 'logo placement of row '+(++i)+', side is required';
            }
          }
        }
      }

      if(this.journey.allow_name_number) {
        if (!this.journey.name_number_fonts || this.journey.name_number_fonts.length == 0) {
          valid = false;
          message = 'Fonts of name/number placement is required';
        } else if (!this.journey.name_number_colors || this.journey.name_number_colors.length == 0) {
          valid = false;
          message = 'Color containers of name/number placement is required';
        } else {
          for (let i = 0; i < this.journey.product_texts.length; i++) {
              let parent_placement = this.journey.product_texts[i];
              if (parent_placement.label == '') {
                valid = false;
                message = 'Label of  placement of row '+(++i)+' is required';
                break;
              }else if(parent_placement.type.label == ''){
                valid = false;
                message = 'Placement of row '+(++i)+' is required';
                break;
              }
              for (let j = 0; j< this.journey.product_texts[i].items.length; j++){
                let placement = this.journey.product_texts[i].items[j];
                if (placement.x_axis == '' || !RegExp.test(placement.x_axis)) {
                  valid = false;
                  message = 'x-axis of name/number placement of row '+(++j)+' is required';
                  break;
                }else if(placement.y_axis == '' || !RegExp.test(placement.y_axis)){
                  valid = false;
                  message = 'Y-axis of name/number placement of row '+(++j)+' is required';
                  break;
                }else if(!RegExp.test(placement.rotation)){
                  valid = false;
                  message = 'Rotation of name/number placement of row '+(++j)+' is required';
                  break;
                }
                else if(placement.height == '' || !RegExp.test(placement.height)){
                  valid = false;
                  message = 'height of name/number placement of row '+(++j)+' is required';
                  break;
                }else if(parseFloat(placement.height) < 10){
                  valid = false;
                  message = 'height of name/number placement of row '+(++j)+' should be greater than or equal to 10';
                }
                else if(!placement.placement || placement.placement == ''){
                  valid = false;
                  message = 'Side of name/number placement of row '+(++j)+' is required';
                  break;
                }
                else if(!placement.label || placement.label == ''){
                  valid = false;
                  message = 'Label of name/number placement of row '+(++j)+' is required';
                  break;
                }

              }
          }
        }
      }
      if(!valid){
        this.showToast(message, 'DANGER');
      }
      return valid;
    },
    removeNumRow(index){
      this.journey.name_numbers_placement.splice(index, 1);
    },
    removeChildNumRow(index,child_index){
      this.journey.name_numbers_placement[index].name_of_placement_follow.splice(child_index, 1);
    },
    removeLogoPlacement(index){
      this.journey.logos_setting.splice(index, 1);
    },
    addNameNumRow(){
      this.journey.name_numbers_placement.push({
        x_axis: '',
        y_axis: '',
        rotation: '',
        // height: '',
        height: '',
        side: {id: 'front', label: 'Front'},
        arc_text_allowed: false,
        outline_enabled: false,
        type: {id: 'name', label: 'Name'},
        is_locked:false,
        name_of_placement_follow:[]
      })
      this.addValidationRules();
    },

    AddLogoPlacement(){
      this.journey.logos_setting.push({
        x_axis: '',
        y_axis: '',
        rotation: '',
        height: '',
        // height: '',
        side: '',
        is_locked: false,
      });
      this.addValidationRules();
    },
    LimitLogoPlacement(){
      this.journey.logos_setting = this.journey.logos_setting.slice(0, this.journey.max_logo_allowed);
      // if(isNaN(this.journey.max_logo_allowed)){
      //   this.showToast('should be only integer', 'DANGER');
      //   this.journey.max_logo_allowed = 1;
      // }else{
      //   if(this.journey.logos_setting.length > this.journey.max_logo_allowed);
      //     this.journey.logos_setting.length = this.journey.max_logo_allowed;
      // }
    },
    getFollowingProduct(product_ids){
      let new_product_ids = []
      if (product_ids != null){
        if (typeof(product_ids) == "string"){
          product_ids = JSON.parse(product_ids)
        }
        this.product_ids.forEach(product => {
          product_ids.forEach(ids => {
            if (ids == product.id){
              let obj = {
                id: ids,
                label:product.label
              }
              new_product_ids.push(obj)
            }
          })
        })
      }
      return new_product_ids
    },
    addValidationRules(){
      let total_logos = this.journey.logos_setting.length;
      for(let i=0; i<total_logos; i++){
        this.design_error_messages.custom[`logo_position_x_${i}`] = {
          required: 'Logo x-axis position is required',
          decimal: 'Logo x-axis position can contains only numbers'
        }
        this.design_error_messages.custom[`logo_position_y_${i}`] = {
          required: 'Logo y-axis position is required',
          decimal: 'Logo y-axis position can contains only numbers'
        }
        this.design_error_messages.custom[`logo_rotate_${i}`] = {
          required: 'Logo rotate is required',
          decimal: 'Logo rotate can contains only numbers'
        }
        this.design_error_messages.custom[`logo_height_${i}`] = {
          required: 'Logo height is required',
          decimal: 'Logo height can contains only numbers',
          min_value:'Logo height should be greater than or equal to 10'
        }
        this.design_error_messages.custom[`logo_placement_${i}`] = {
          required: 'logo name of placement is requiredd'
        }
        this.design_error_messages.custom[`logo_side_${i}`] = {
          required: 'Logo side is required'
        }
        if (i != 0){
          this.design_error_messages.custom[`logo_following_${i}`] = {
            required: 'Product is required'
          }
        }
      }

      let total_names = this.journey.product_texts.length;
      this.journey.product_texts.forEach((product_text, productTextIndex) => {
        this.design_error_messages.custom[`product_text_${productTextIndex}_label`] = {
          required: 'Name placement is required'
        }
        this.design_error_messages.custom[`product_text_${productTextIndex}_type`] = {
          required: 'text type is required'
        }
        product_text.items.forEach((product_text_item, productTextItemIndex) => {
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_x_position`] = {
            required: 'x-axis position is required',
            decimal: 'x-axis position can contains only numbers and upto 5 decimal number'
          }
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_y_position`] = {
            required: 'y-axis position is required',
            decimal: 'y-axis position can contains only numbers and upto 5 decimal number'
          }
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_rotation`] = {
            required: 'rotation is required',
            decimal: 'rotation can contains only numbers and upto 5 decimal number'
          }
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_height`] = {
            required: 'height is required',
            decimal: 'height can contains only numbers and upto 5 decimal number'
          }
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_label`] = {
            required: 'label is required'
          }
          this.design_error_messages.custom[`product_text_${productTextIndex}_item_${productTextItemIndex}_placement`] = {
            required: 'placement is required'
          }
        })
      })

      this.$validator.localize('en', this.design_error_messages);
    },
    addChildNamePlacement(index){
      this.journey.name_numbers_placement[index].name_of_placement_follow.push({
        x_axis: '',
        y_axis: '',
        rotation: '',
        // height: '',
        height: '',
        side: {id: 'front', label: 'Front'},
        arc_text_allowed: false,
        outline_enabled: false,
        type: this.journey.name_numbers_placement[index].type,
        is_locked:false
      })
      this.addValidationRules();
    },
    textPlacementValue(item) {
      if (!item.placement) return null;
      if (!this.is_reversible) return item.placement;
      return `${item.placement} (${item.face || 'outside'})`;
    },
    setTextPlacement(item, value) {
      if (!value) {
        item.placement = null;
        return;
      }
      const match = String(value).match(/^(Front|Back)(?: \((outside|inside)\))?$/);
      item.placement = match ? match[1] : value;
      this.$set(item, 'face', match && match[2] ? match[2] : 'outside');
    },
    getProductTextsDefaultObject(text_item_only= false) {
      let text_item  = { x_axis: '',  y_axis: '',  rotation: '',  height: '',  label:"",  placement: 'Front',  face: 'outside',  arc_text_allowed: false,
        outline_enabled: false, is_locked: false,
      }
      if(text_item_only)
        return text_item
      return  { id: null,  product_id: this.$route.params.id ? this.$route.params.id : null,  type: null,  label: null,  following_products: [],  items: [text_item],
      }
    },
    setProductTexts(product_texts) {
      let self = this;
      if(product_texts.length == 0) {
        self.journey.product_texts =  [self.getProductTextsDefaultObject()];
      } else {
        // Reversible products (AB#19680): items saved before the face field
        // existed default to the outside face.
        self.journey.product_texts = product_texts.map(text => ({
          ...text,
          items: (text.items || []).map(item => ({ face: 'outside', ...item })),
        }));
      }
    },
    addProductText(type, product_text_index) {
      let self = this;
      if(type ==  'product_item') {
        self.journey.product_texts[product_text_index].items.push(self.getProductTextsDefaultObject(true));
      } else {
        self.journey.product_texts.push(self.getProductTextsDefaultObject());
      }

    },
    removeProductText(product_text_index, product_text_item_index = -1) {
      let self = this;
      if(product_text_item_index >= 0)
        self.journey.product_texts[product_text_index].items.splice(product_text_item_index, 1);
      self.journey.product_texts.splice(product_text_item_index, 1);

    }
  },
}
</script>

<style lang="scss" scoped>
  .default-logo, .selected_logo{
    max-width: 72px;
    max-height: 72px;
  }
  .cursur_pointer{
    cursor: pointer;
    color: red;
  }
  .btn-primary{
    background: #009FE3;
    border-color: #009FE3;
    font-size: 20px;
    padding: 0.5rem 2rem;
  }
  .btn-primary.light{
    background: #c8e4f3 !important;
    border-color: #c8e4f3 !important;
    color: #009FE3 !important;
  }
  .color-data-container-row .dropdown_wrapper div.v-select,
  .font-container-row .dropdown_wrapper div.v-select{
    height: auto;
  }

  .remove-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
    height: 30px;
    width: 30px;
    background: #C80000;
    color: #fff;
    border-radius: 99px;
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
    transition: 0.2s all ease;
    z-index: 30;
  }

  .remove-icon:hover{
    background: #ff0000;
  }

  .alter-rows+.alter-rows{
    margin-top: 20px;
  }

  .alter-rows:nth-child(even) .row-style{
    background: #f5f5f5;
  }

  .row-style{
    position: relative;
    width: 100%;
    border: 1px solid #eee;
    padding: 13px 0;
    border-radius: 10px;
  }
  .v-image{
    border: 1px solid rgb(200, 0, 0);
    border-radius:10px;
  }
</style>